import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["daySlots"]

  addSlot(event) {
    const day = event.currentTarget.dataset.day
    const container = this.daySlotsTargets.find((target) => target.dataset.day === day)
    if (!container) return

    const templateRow = container.querySelector(".schedule-slot")
    if (!templateRow) return

    const newRow = templateRow.cloneNode(true)
    newRow.querySelectorAll("input").forEach((input) => {
      input.value = ""
    })

    container.appendChild(newRow)
  }

  removeSlot(event) {
    const row = event.currentTarget.closest(".schedule-slot")
    if (!row) return

    const container = row.parentElement
    const rows = container.querySelectorAll(".schedule-slot")

    if (rows.length <= 1) {
      row.querySelectorAll("input").forEach((input) => {
        input.value = ""
      })
      return
    }

    row.remove()
  }
}
